export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8012.a33224a3.jpg";